import React, { useState } from 'react';
import { IconButton, Popover, TextField } from '@material-ui/core';
import InfoIcon from '@material-ui/icons/Info';
import styled from 'styled-components';

const PopoverContainer = styled.div`
  padding: 10px;
  min-width: 280px;
  max-width: 280px;
  max-height: 400px;
  white-space: pre-wrap;
  font-size: 13px;
`;

const getIconColor = (hasText) =>
  hasText ? { color: 'primary' } : { htmlColor: '#c5c1c1ff' };

export const StartReasonPopover = ({ medication, handleChange, readonly }) => {
  const [hasText, setHasText] = useState(!!medication.startreason);
  const [anchorEl, setAnchorEl] = useState(null);
  const [text, setText] = useState('');

  const handleClick = (event) => {
    setText(medication.startreason || '');
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    const trimmed = text.trim();
    const current = (medication.startreason || '').trim();
    if (!readonly && trimmed !== current) {
      setHasText(!!trimmed);
      handleChange(medication, 'startreason', trimmed, { skipRefresh: true });
    }
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'startreason-popover' : undefined;

  return (
    <div>
      <IconButton aria-describedby={id} size="small" onClick={handleClick}>
        <InfoIcon fontSize="small" {...getIconColor(hasText)} />
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <PopoverContainer>
          {!readonly ? (
            <TextField
              multiline
              minRows={3}
              fullWidth
              label="Start Reason"
              value={text}
              focused
              inputProps={{ style: { fontSize: '13px' } }}
              onChange={(e) => setText(e.target.value)}
            />
          ) : (
            medication.startreason || <em>No notes</em>
          )}
        </PopoverContainer>
      </Popover>
    </div>
  );
};
